<div style="position: relative; top: 0%; left: 1%; width: 97%;">
  <h2>{{ 'AUTH.INVITE_TITLE' | translate }}</h2>

  @if (!localEnabled) {
    <div class="alert alert-warning" style="max-width: 640px;">
      {{ 'AUTH.INVITE_UNAVAILABLE' | translate }}
    </div>
  } @else {
    <p style="max-width: 640px; color: var(--fg-3);">{{ 'AUTH.INVITE_LEDE' | translate }}</p>

    @if (errorKeys.length) {
      <div class="alert alert-danger" style="max-width: 640px;">
        @for (key of errorKeys; track key) { <div>{{ key | translate }}</div> }
      </div>
    }

    <form (ngSubmit)="submit()" #inviteForm="ngForm" style="max-width: 640px;">
      <div class="form-group mb-3">
        <label class="fw-semibold" for="username">{{ 'USER.USERNAME' | translate }}</label>
        <input type="email" class="form-control" id="username" name="username"
               [(ngModel)]="username" required email autocomplete="off" #usernameField="ngModel">
        <div [hidden]="usernameField.valid || usernameField.pristine" class="alert alert-danger mt-1">
          {{ 'AUTH.USERNAME_MUST_BE_EMAIL' | translate }}
        </div>
      </div>

      <div class="form-group mb-3">
        <label class="fw-semibold" for="name">{{ 'USER.FIRSTNAME' | translate }}</label>
        <input type="text" class="form-control" id="name" name="name" [(ngModel)]="name">
      </div>

      <div class="form-group mb-3">
        <label class="fw-semibold" for="surname">{{ 'USER.LASTNAME' | translate }}</label>
        <input type="text" class="form-control" id="surname" name="surname" [(ngModel)]="surname">
      </div>

      <div class="mb-4">
        <label class="fw-semibold">{{ 'USER.ROLES' | translate }}</label>
        @for (role of roleKeys; track role) {
          <div class="form-check form-switch mt-1">
            <input class="form-check-input" type="checkbox" [id]="'role_' + role" [name]="'role_' + role"
                   [ngModel]="hasRole(role)" (ngModelChange)="toggleRole(role, $event)">
            <label class="form-check-label" [for]="'role_' + role">
              {{ ('USER.' + role) | translate }}
            </label>
          </div>
        }
      </div>

      <p style="color: var(--fg-3); font-size: 0.85rem; max-width: 640px;">
        {{ 'AUTH.INVITE_NOTE' | translate }}
      </p>

      <div class="d-flex gap-2">
        <button type="button" class="btn btn-outline-secondary" [disabled]="busy" (click)="cancel()">
          {{ 'FUNCTION-BUTTONS.CANCEL' | translate }}
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="busy || !inviteForm.form.valid">
          {{ 'AUTH.INVITE_SUBMIT' | translate }}
        </button>
      </div>
    </form>
  }
</div>
